export default [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "aol.com",
  "icloud.com",
  "me.com",
  "nyu.edu",
  "outlook.com",
  "mac.com",
  "msn.com",
  "live.com",
  "comcast.net",
  "columbia.edu",
  "optonline.net",
  "verizon.net",
  "elliman.com",
  "ymail.com",
  "cornell.edu",
  "compass.com",
  "Corcoran.com",
  "nyc.rr.com",
  "qq.com",
  "earthlink.net",
  "umich.edu",
  "fordham.edu",
  "aim.com",
  "newschool.edu",
  "mail.ru",
  "Kw.com",
  "sbcglobal.net"
];
